<div class="chat-messages" [ngClass]="{'suggest-article-enabled': isArticleSuggestionEnabled, 'smart-advisor2-enabled': isSmartAdvisor2Enabled}">
  <app-auto-answers [isActiveChat]="isActive" [chatId]="workItemId" *ngIf="isChatWorkItemType()"></app-auto-answers>

  <ng-container *ngIf="isFontSizeAccessibilitySettingTurnedOn">
    <div class="system-msg-font-size {{getAccessibilityClass()}}">
      <span>{{ 'bcChatMessages.accessibilitySettingText' | translate }}</span>
    </div>

    <app-accessibility-font-size-setter (fontSizePercentageChanged)="onFontSizePercentageChanged($event)" (setDefaultFontSizePercentage)="onDefaultFontSizePercentageSet()"></app-accessibility-font-size-setter>
  </ng-container>

  <div class="bc-timestamp {{ getAccessibilityClass() }}" [attr.data-automation-id]="'bc-chat-started-timestamp'">
    <span>{{ formattedWorkItemCreated }}</span>
    <app-copy-text-to-clipboard [linkText]="translatedCopyText" [textToCopy]="workItemId"></app-copy-text-to-clipboard>
  </div>

  <div *ngFor="let message of messages; let i = index">
    <!--
      Chat messages are HTML. SMS/Facebook messages are plain text.
    -->

    <div class="bc-visitor-messages clearfix"
         *ngIf="message.type === types.VISITOR"
         [attr.data-automation-id]="'bc-chat-visitor-messages'">
      <div *ngFor="let msg of message.messages"
           class="chat-message clearfix chat-message-received"
           [ngClass]="{'chat-message-received-interactive': isInteractiveType(getType(msg))}"
           [attr.data-automation-id]="'bc-chat-message-received'">
        <div class="chat-message-text js-chat-message-text {{getAccessibilityClass()}}" [ngSwitch]="getType(msg)">
          <div class="chat-message-inner" [innerHTML]="msg.Text" *ngSwitchDefault></div>
          <div class="chat-message-inner" [innerHTML]="sanitizeMessage(msg.Text) | linky:{newWindow: true, stripPrefix: false}" *ngSwitchCase="'link'"></div>
          <img class="chat-message-inner" appImageOrientation [src]="getUrl(msg)" *ngSwitchCase="'image'"/>
          <list-picker-message [direction]="'received'" [listPickerJson]="msg.JsonData" *ngSwitchCase="'listPicker'"></list-picker-message>
          <time-picker-message [direction]="'received'" [timePickerJson]="msg.JsonData" *ngSwitchCase="'timePicker'"></time-picker-message>
          <div class="chat-message-inner" *ngSwitchCase="'interactive'" [innerHTML]="getInteractiveText(msg)"></div>
          <div class="chat-message-inner" *ngSwitchCase="'video'">
            <video [src]="getUrl(msg)" controls autoplay></video>
          </div>
          <div class="chat-message-inner" *ngSwitchCase="'download'">
            <a href="{{getUrl(msg)}}" title="{{getName(msg)}}">{{ 'bcChatMessages.download' | translate }}</a>
          </div>
        </div>
      </div>
    </div>

    <div class="bc-operator-messages clearfix"
         *ngIf="message.type === types.OPERATOR"
         [attr.data-automation-id]="'bc-chat-operator-messages'">
      <div *ngFor="let msg of message.messages"
           class="chat-message clearfix chat-message-sent"
           [ngClass]="{'chat-message-sent-interactive': isInteractiveType(getType(msg)), 'joined-operator-message': !isOwnMessage(message.personId)}"
           [attr.data-automation-id]="'bc-chat-message-sent'">
        <div class="chat-message-text js-chat-message-text {{getAccessibilityClass()}}" [ngSwitch]="getType(msg)">
          <div class="chat-message-inner" [innerHTML]="msg.Text | appOperatorChatMessageFormat | appSafeHtml" *ngSwitchDefault></div>
          <div class="chat-message-inner" [innerHTML]="msg.Text | linky:{newWindow: true, stripPrefix: false}" *ngSwitchCase="'link'"></div>
          <img class="chat-message-inner" appImageOrientation [src]="getUrl(msg)" *ngSwitchCase="'image'"/>
          <list-picker-message [direction]="'sent'" [listPickerJson]="msg.JsonData" *ngSwitchCase="'listPicker'"></list-picker-message>
          <time-picker-message [direction]="'sent'" [timePickerJson]="msg.JsonData" *ngSwitchCase="'timePicker'"></time-picker-message>
          <div class="chat-message-inner" *ngSwitchCase="'interactive'" [innerHTML]="getInteractiveText(msg)"></div>

          <div class="chat-message-inner" *ngSwitchCase="'video'">
            <video [src]="getUrl(msg)" controls autoplay></video>
          </div>
          <div class="chat-message-inner" *ngSwitchCase="'download'">
            <a href="{{ getUrl(msg)}}" title="{{ getName(msg)}}">{{ 'bcChatMessages.download' | translate }}</a>
          </div>
        </div>

        <div *ngIf="isSmartAdvisor2Enabled" class="chat-message--suggestion-block">
          <div class="chat-message--suggestion-holder">
            <button class="chat-message--suggestion-popup-button" [ngClass]="{'chat-message--suggestion-popup-button--clicked': msg.clickedSuggestion}" (click)="toggleSuggestionButtonVisibility(msg)"><i></i><i></i><i></i></button>
            <button class="chat-messages--suggestion-action-button" (click)="proposeArticle(msg, i)">{{ 'bcChatMessages.suggestArticle' | translate}}</button>
          </div>
        </div>

        <div *ngIf="!isSmartAdvisor2Enabled && isArticleSuggestionEnabled" class="overlay-send-to-smart-advisor" [ngClass]="{'action-message': !msg.propose}">
          <div class="send-to-smart-advisor-message" [attr.data-automation-id]="'bc-send-to-smart-advisor-message'">{{ (msg.propose || 'bcChatMessages.suggestArticle') | translate}}</div>
          <button *ngIf="(msg.propose !== 'bcChatMessages.articleWasSent') && (msg.propose !== 'bcChatMessages.articleSuggestionInProgress')"
                  class="send-to-smart-advisor-button"
                  (click)="proposeArticle(msg, i)"
                  [attr.data-automation-id]="'bc-send-to-smart-advisor-button'">
            <svg-icon icon="send-to-smart-advisor" class="send-to-smart-advisor-icon"></svg-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="bc-system-messages" *ngIf="message.type === types.SYSTEM">
      <div *ngFor="let msg of message.messages" class="chat-message">
        <div class="chat-message-text {{getAccessibilityClass()}}">
          <div class="chat-message-inner" *ngIf="isChatWorkItemType()">
            <span class="system-msg system-msg-timestamp">{{ getMessageFormattedDate(msg) }}</span>
            <span class="system-msg" [innerHTML]="msg.Text"></span>
          </div>
          <div class="chat-message-inner" *ngIf="!isChatWorkItemType()">
            <span class="system-msg system-msg-timestamp">{{ getMessageFormattedDate(msg) }}</span>
            <ng-container [ngSwitch]="getType(msg)">
              <span class="system-msg" *ngSwitchDefault [innerHTML]="msg.Text | linky:{newWindow: true, stripPrefix: false}"></span>
              <img class="system-msg" [src]="getUrl(msg)" appImageOrientation *ngSwitchCase="'image'"/>
              <span class="system-msg" *ngSwitchCase="'interactive'" [innerHTML]="getInteractiveText(msg)"></span>
              <span class="system-msg" *ngSwitchCase="'video'">
                <video [src]="getUrl(msg)" controls autoplay></video>
              </span>
              <span class="system-msg" *ngSwitchCase="'download'">
                <a href="{{getUrl(msg)}}" title="{{getName(msg)}}">{{ 'bcChatMessages.download' | translate }}</a>
              </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="message.type !== types.SYSTEM" [ngClass]="{ 'bc-operator-last-message': message.type === types.OPERATOR, 'bc-visitor-last-message': message.type === types.VISITOR }" class="bc-timestamp {{getAccessibilityClass()}}">
      <span>{{ getLastMessageFormattedDate(message) }}</span>
      <span *ngIf="message.type === types.OPERATOR">{{ getLastMessageFormattedOperatorName(message) }}</span>
    </div>
  </div>

  <video-chat-status-bubble *ngIf="isVideoFeatureEnabled && isActive"
                            [workItemId]="workItemId"
                            [workItemType]="workItemType">
  </video-chat-status-bubble>

  <remote-control-session-status-bubble *ngIf="isRemoteControlFeatureEnabled && hasActiveRemoteControl && isActive"
                                [workItemId]="workItemId"
                                [workItemType]="workItemType">
  </remote-control-session-status-bubble>

  <div *ngIf="isActive === false" class="bc-timestamp bc-ended-message e2e-ended-text-chat {{getAccessibilityClass()}}" role="alert">
    <span>{{ 'bcChatMessages.endedState' | translate }}</span>
  </div>
</div>
